import React, { useEffect } from 'react';
import {Link} from 'react-router-dom'

import Resume from '../../assets/img/Resume-Mussagy-Remane.pdf'
import AOS from 'aos'
import 'aos/dist/aos.css';

const CallToAction = () => {
  useEffect(() => {
    AOS.init({duration: 800})
  }, []);

  return (
    <div className='call-to-action' data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="500">
      <a href={Resume} download className='btn'>Donwload Resume</a>
      <Link to="/contact" className='btn btn-primary'>Let's Talk</Link>
    </div>
  );
}

export default CallToAction;
